<label for="{{optionId}}">
    <input id="{{optionId}}" (click)="toggleCheck()" type="checkbox" [checked]="isChecked" [value]="option.value" />
    <span *ngIf="!toTranslate">{{ option.label }}</span>
    <span *ngIf="toTranslate">{{ option.label | uppercase | translate }}</span>
</label>
